const ITEMS = [
  { name: "Austria", code: "at" },
  { name: "Belgium", code: "be" },
  { name: "Bulgaria", code: "bg" },
  { name: "Croatia", code: "hr" },
  { name: "Czechia", code: "cz" },
  { name: "Denmark", code: "dk" },
  { name: "Estonia", code: "ee" },
  { name: "Finland", code: "fi" },
  { name: "France", code: "fr" },
  { name: "Germany", code: "de" },
  { name: "Greece", code: "gr" },
  { name: "Hungary", code: "hu" },
  { name: "Iceland", code: "is" },
  { name: "Italy", code: "it" },
  { name: "Latvia", code: "lv" },
  { name: "Liechtenstein", code: "li" },
  { name: "Lithuania", code: "lt" },
  { name: "Luxembourg", code: "lu" },
  { name: "Malta", code: "mt" },
  { name: "Netherlands", code: "nl" },
  { name: "Norway", code: "no" },
  { name: "Poland", code: "pl" },
  { name: "Portugal", code: "pt" },
  { name: "Romania", code: "ro" },
  { name: "Slovakia", code: "sk" },
  { name: "Slovenia", code: "si" },
  { name: "Spain", code: "es" },
  { name: "Sweden", code: "se" },
  { name: "Switzerland", code: "ch" },
  { name: "United States", code: "us" },
  { name: "United Kingdom", code: "gb" },
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-[#F3F3F1] border-y border-slate-200 py-6 overflow-hidden"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="flex items-center gap-4 whitespace-nowrap px-10">
                  <img
                    src={`https://flagcdn.com/w40/${item.code}.png`}
                    alt={`${item.name} flag`}
                    loading="lazy"
                    className="w-6 h-[18px] object-cover rounded-[3px] shadow-sm"
                  />
                  <span className="font-display text-xl sm:text-2xl text-slate-500">
                    {item.name}
                  </span>
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-slate-300" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
